export const validateMobilePaymentGsm = ({ record, values, form }) => {
  const getCurrentLanguage = () => localStorage.getItem('language')?.slice(1, -1);

  const isEnglishLanguage = () => getCurrentLanguage() === 'en';
  const isEnglish = isEnglishLanguage();
  if (!record.cardType && values?.hasMobilePayment) {
    if (!values?.gsm?.length) {
      form.setFields([
        {
          name: 'gsm',
          errors: [isEnglish ? 'This field is required.' : 'Bu Alan Zorunludur.'],
        },
      ]);
      return false;
    }
  }
  return true;
};
